"use strict";
/**
 * @module Services.MetricCollectors
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var session_metric_collector_1 = require("./session-metric-collector");
/**
 * Serialiser for {@link SessionMetricCollector}
 */
var SessionMetricCollectorSerialiserClass = /** @class */ (function (_super) {
    __extends(SessionMetricCollectorSerialiserClass, _super);
    function SessionMetricCollectorSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link SessionMetricCollector} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link SessionMetricCollector} that was read
     */
    SessionMetricCollectorSerialiserClass.prototype.read = function (bis) {
        var name = Codec.readString(bis);
        var exportToPrometheus = Codec.readBoolean(bis);
        var removeMetricsWithNoMatches = Codec.readBoolean(bis);
        var sessionFilter = Codec.readString(bis);
        var groupByProperties = Codec.readCollection(bis, Codec.readString);
        return new session_metric_collector_1.SessionMetricCollectorImpl(name, exportToPrometheus, removeMetricsWithNoMatches, sessionFilter, groupByProperties);
    };
    /**
     * Write a {@link SessionMetricCollector} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link SessionMetricCollector} to be written
     */
    SessionMetricCollectorSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.name);
        Codec.writeBoolean(bos, value.exportToPrometheus);
        Codec.writeBoolean(bos, value.removeMetricsWithNoMatches);
        Codec.writeString(bos, value.sessionFilter);
        Codec.writeCollection(bos, value.groupByProperties, Codec.writeString);
    };
    return SessionMetricCollectorSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.SessionMetricCollectorSerialiserClass = SessionMetricCollectorSerialiserClass;
/**
 * The singleton
 */ // tslint:disable-next-line:variable-name
exports.SessionMetricCollectorSerialiser = new SessionMetricCollectorSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/metric-collectors/session-metric-collector-serialiser.js
// module id = 808
// module chunks = 1